export const AUTHORZIER_TYPES = {
  NONE: 'none',
  API_KEY: 'api_key',
  OIDC: 'oidc',
};

export function normalizeStringList(raw_value) {
  if (!raw_value) return [];
  if (Array.isArray(raw_value)) {
    return raw_value.map((v) => String(v).trim()).filter((v) => v);
  }
  return String(raw_value)
    .split('\n')
    .map((v) => v.trim())
    .filter((v) => v);
}

export function claimsObjectToRows(required_claims) {
  if (!required_claims || typeof required_claims !== 'object') {
    return [];
  }
  return Object.entries(required_claims).map(([claim, values]) => ({
    claim,
    values: Array.isArray(values)
      ? values.map((v) => String(v)).filter((v) => v)
      : [],
  }));
}

export function rowsToClaimsObject(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return undefined;
  }

  const result = {};
  rows.forEach((row) => {
    const claim = row?.claim?.trim();
    if (!claim) {
      return;
    }
    const values = (row.values || [])
      .map((v) => String(v).trim())
      .filter((v) => v);
    if (values.length) {
      result[claim] = values;
    }
  });

  return Object.keys(result).length ? result : undefined;
}
